import { Mixins, Component, Prop } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

@Component({
    inheritAttrs: false,
    name: 'DialogWrapper',
})
export default class DialogWrapper extends Mixins<MixinInterface>() {
    @Prop({ required: true }) dialogComponent!: any
    @Prop({ required: true }) props!: any

    closeDialog() {
        this.$emit('close', false)
    }

    created() {
        const onEscape = (e) => {
            if (e.keyCode == 27) {
                this.closeDialog()
            }
        }
        document.addEventListener('keydown', onEscape)
        this.$once('hook:destroyed', () => {
            document.removeEventListener('keydown', onEscape)
        })
    }
}
